module.exports = __webpack_public_path__ + "static/mary-kay-7-d7415e6d6d44c5b2be7049a394d36549.jpg";